import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useEffect, useRef } from 'react';
import { createWrappedError } from '@/utils/errors';
import cdn from '@/services/cdn';
const PREFIX = 'common: hooks: useWidgetConfig:';
// Request the config of a widget by
// its' ID and return result as a widget
export default function useWidgetConfig(widgetId) {
  const isRequesting = useRef(false);
  const {
    0: result,
    1: setResult
  } = useState({
    status: 'loading',
    error: null,
    data: null
  });
  useEffect(() => {
    if (!widgetId || isRequesting.current) return;
    isRequesting.current = true;
    cdn.getCDNWidgetConfig(widgetId).then(widgetConfig => {
      setResult({
        data: widgetConfig,
        status: 'success',
        error: null
      });
    }).catch(err => {
      setResult({
        error: createWrappedError(`${PREFIX} failed to download widget config JSON`, err),
        status: 'failure',
        data: null
      });
    }).finally(() => {
      isRequesting.current = false;
    });
  }, [widgetId]);
  return result;
} // Get the config of a widgets reporter
// return original widget if it is reporting

export function useReportingWidgetConfig(widget) {
  const isRequesting = useRef(false);
  const {
    0: result,
    1: setResult
  } = useState({
    status: 'loading',
    error: null,
    data: null
  });
  useEffect(() => {
    if (!widget || isRequesting.current) return; // Provided widget is the reporter

    if (widget && !widget.reportingWidget) {
      return setResult({
        data: _objectSpread({}, widget),
        status: 'success',
        error: null
      });
    }

    if (!widget.reportingWidget || !widget.reportingWidget.id) {
      throw Error(`${PREFIX} useReportingWidgetConfig: malformed subscriber widget has no reporting widget ID`);
    } // Reporter


    isRequesting.current = true;
    cdn.getCDNWidgetConfig(widget.reportingWidget.id).then(widgetConfig => {
      setResult({
        data: widgetConfig,
        status: 'success',
        error: null
      });
    }).catch(err => {
      setResult({
        error: createWrappedError(`${PREFIX} useReportingWidgetConfig: failed to download reporting widget config JSON`, err),
        status: 'failure',
        data: null
      });
    }).finally(() => {
      isRequesting.current = false;
    });
  }, [widget]);
  return result;
}